import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";

import { AnimatePresence, motion } from "framer-motion";
import { ReactComponent as BlankImg } from "../../assets/imgs/blankImg.svg";
import InfoDropdown from "../Fold2/InfoDropdown";

const OptimizeCampaigns = () => {
  const goToBenefits = () => {
    let element = document.getElementById("benefits");
    element.scrollIntoView({ behavior: "smooth" });
  };

  const dropdownList = [
    {
      id: 0,
      dropdownTitle: "Reliable, Actionable Data",
      title: "Track Installs, Engagement, ROI, and More",
      text: "Get full visibility into who accessed your links, what actions they took, and how each link is performing. See installs, re-engagements, and conversions—down to the campaign level.",
      learnMore: "",
    },
    {
      id: 1,
      dropdownTitle: "Campaign Management",
      title: "Group and Compare Campaigns Easily",
      text: "Organize all your links under specific campaigns to track performance at a glance. Compare results across multiple campaigns to see what’s working and where to optimize.",
      learnMore: "",
    },
    {
      id: 2,
      dropdownTitle: "Seamless Integration",
      title: "Connect Ad Sources and App Stores in Minutes",
      text: "Easily integrate your ad networks, analytics tools, and app store accounts—no complex setup required. Everything syncs into one streamlined dashboard.",
      learnMore: "",
    },
    {
      id: 3,
      dropdownTitle: "Data Exports",
      title: "Access and Share Data Freely",
      text: "TExport detailed campaign and link performance data via CSV or API for deeper analysis, custom dashboards, or internal reporting.",
      learnMore: "",
    },
    {
      id: 4,
      dropdownTitle: "Smarter Scaling",
      title: "Invest in What Works, Cut What Doesn’t",
      text: "Quickly identify your best-performing ads and links. Reallocate budget to top campaigns and eliminate underperformers to maximize ROI.",
      learnMore: "",
    },
  ];

  return (
    <FullPageContainer>
      <Container id={"optimizeCampaigns"}>
        <Line>
          <TextWrapper>
            <Title>Optimize Campaigns with Data-Driven Insights</Title>
            <Subtitle>
              Group your links into campaigns, connect all your ad sources, and
              get real-time performance data across installs, re-engagements,
              and ROI. Export reports easily and focus your budget where it
              drives the most impact.
            </Subtitle>
          </TextWrapper>
        </Line>
        <AnimatePresence>
          <Line>
            <Column>
              {dropdownList.map((item) => (
                <InfoDropdown
                  key={item.id}
                  dropdownTitle={item.dropdownTitle}
                  title={item.title}
                  infoText={item.text}
                  learnMoreClick={item.learnMore}
                />
              ))}
            </Column>
          </Line>
        </AnimatePresence>
      </Container>
    </FullPageContainer>
  );
};

export default OptimizeCampaigns;

const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 0px 80px 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  margin: auto;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
  }
`;

const Line = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};
  @media (max-width: 990px) {
    gap: 10px;
    flex-direction: column;
  }
`;

const Column = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
`;
